import { render, staticRenderFns } from "./cgv.vue?vue&type=template&id=172895a0&"
import script from "./cgv.vue?vue&type=script&lang=js&"
export * from "./cgv.vue?vue&type=script&lang=js&"
import style0 from "./cgv.vue?vue&type=style&index=0&id=172895a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Breadcrumb.vue').default})
